import { ProfanityFilterService } from 'Services/ServiceFactory';
import { t } from 'Utils/localization/i18next';

export const checkForProfanityWords = dataForValidation => {
  if (dataForValidation) {
    const profanityFilterResponse = ProfanityFilterService.doProfanityCheck(
      dataForValidation
    );
    // Got profanity errors
    if (profanityFilterResponse) {
      return profanityFilterResponse;
    }
  }
  // No profanity errors
  return true;
};

export const getProfanityError = (errorKey, profanityWord, fieldName) => [
  t(errorKey, { profanityWord, fieldName: t(`forms.${fieldName}`) })
];
